export const dtGPTState = {
  chats: [],
  conversations: [],
  chat: {
    conversation_id: "undefined",
    title: "Chat",
    messages: [
      
    ],
  },
  sendChatMessageLoading: false,
}